import { KnockFeedProvider, KnockProvider } from "@knocklabs/react";
import { environmentConfig } from "@src/appV2/environment";
import { knock } from "@src/appV2/environment/config";
import { type ReactNode } from "react";

import {
  KnockGuideProviderWithRefetch,
  type KnockGuideProviderWithRefetchProps,
} from "./KnockGuideProviderWithRefetch";

interface KnockProviderWrapperProps {
  children: ReactNode;
  userId: string | undefined;
  knockToken: string | undefined;
  onUserTokenExpiring: () => Promise<string | undefined>;
  targetParams?: KnockGuideProviderWithRefetchProps["targetParams"];
}

/**
 * Knock only supports authenticated users as of 2025-10-30, so we cannot, for example, show outage
 * banners prior to sign-in.
 */
export function KnockProviderWrapper(props: KnockProviderWrapperProps) {
  const { children, userId, knockToken, onUserTokenExpiring, targetParams } = props;

  // Render children without Knock provider if token is not available
  if (!knockToken) {
    return children;
  }

  return (
    <KnockProvider
      apiKey={environmentConfig.REACT_APP_KNOCK_PUBLIC_API_KEY}
      user={{ id: userId }}
      userToken={knockToken}
      onUserTokenExpiring={onUserTokenExpiring}
    >
      <KnockFeedProvider
        feedId={knock.channels.inAppFeed}
        defaultFeedOptions={{ archived: "exclude" }}
      >
        <KnockGuideProviderWithRefetch
          readyToTarget
          channelId={knock.channels.guides}
          targetParams={targetParams}
        >
          {children}
        </KnockGuideProviderWithRefetch>
      </KnockFeedProvider>
    </KnockProvider>
  );
}
